/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import axios from 'axios';
import { SecurityHelper as SecurityUtils } from 'sarsaparilla';
import { CAMP_BASEPATH } from '../constants';

const instance = axios.create({
    baseURL: `${process.env.API}${CAMP_BASEPATH}`,
});

const authInstance = axios.create({
    baseURL: `${process.env.API}${CAMP_BASEPATH}`,
    headers: {
        Authorization: SecurityUtils.getAuthHeader(),
    },
});

authInstance.interceptors.request.use((config) => {
    const newConfig = { ...config };
    newConfig.headers.Authorization = SecurityUtils.getAuthHeader();
    return newConfig;
});

const instanceV2 = axios.create({
    baseURL: `${process.env.API}${CAMP_BASEPATH}`,
});

instanceV2.interceptors.response.use((response) => {
    return response.data;
});

export const campingAxios = instance;
export const authCampingAxios = authInstance;
export const campingAxiosV2 = instanceV2;
